import { Box, Center } from '@chakra-ui/react'

import { Card } from 'containers/Card'

const SIZE_PX: Record<string, number> = {
  xs: 16,
  sm: 24,
  md: 32,
  lg: 40,
  xl: 48,
}

export const BcSpinner = ({ size = 48 }: { size?: number }) => (
  <Box
    w={`${size}px`}
    h={`${size}px`}
    border='3px solid var(--bc-line)'
    borderTopColor='var(--bc-blue)'
    borderRadius='50%'
    style={{ animation: 'bc-spin 0.7s linear infinite' }}
    aria-label='Loading'
    role='status'
  />
)

export const Loading = ({
  size = 'xl',
  ...rest
}: {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  [key: string]: any
}) => (
  <Center
    style={{ width: 'max-content' }}
    layerStyle='centeredLoading'
    {...rest}
  >
    <BcSpinner size={SIZE_PX[size] ?? 48} />
  </Center>
)

export const LoadingCard = ({
  size = 'xl',
  ...rest
}: {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  [key: string]: any
}) => (
  <Card style={{ width: 'max-content' }}>
    <Loading size={size} {...rest} />
  </Card>
)
